module.exports = __webpack_public_path__ + "img/navController-agenda-off.4f137374.png";